import React from "react";

export const Level3 = (props) => {
  const { callback } = props;
  const onClick = (e) => {
    e.preventDefault();
    const num = e.currentTarget.attributes.name.nodeValue;
    callback(num);
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1927.56 1077.17">
      <defs></defs>
      <title></title>
      <g id="Capa_30" data-name="Capa 30">
        <path
          onClick={onClick}
          name="13"
          style={{ fill: "transparent" }}
          d="M142.3,383.72c10-.33,17.88-8.47,23.4-16.79s10.15-17.73,18.41-23.35c6-4.09,13.31-5.7,20.41-7.23l91.39-19.72c2.23-.48,4.74-.91,6.64.34,2.57,1.7,2.58,5.37,2.57,8.45a58.15,58.15,0,0,0,27.07,48.89l-14.06,28.91A11.35,11.35,0,0,1,309,411Q237.29,431.38,164,445.42c-3.12.6-6.61,1.12-9.25-.63-2.3-1.51-3.3-4.3-4.54-6.75-3.51-7-9.71-12.06-15-17.72s-10.15-12.76-9.66-20.53,8.79-15.09,15.91-11.94"
        />
        <path
          onClick={onClick}
          name="15"
          style={{ fill: "transparent" }}
          d="M352.32,382.35a351.68,351.68,0,0,1,37.07-44.19c7.11-7.18,17-14.59,26.37-10.91,6,2.34,9.45,8.46,12.82,13.95A146.12,146.12,0,0,0,460.87,378c3.94,3.2,8.25,6.46,10,11.23,2.1,5.76-.21,12.34-4.08,17.09s-9.11,8.12-14,11.79a121.46,121.46,0,0,0-25.28,25.69c-3.21,4.43-6.56,9.4-11.83,10.92-6.2,1.79-12.55-1.93-17.75-5.75A181.73,181.73,0,0,1,357.46,408c-3.46-4.86-6.76-10.13-7.42-16.05s2.09-12.63,7.67-14.73"
        />
        <path
          onClick={onClick}
          name="4"
          style={{ fill: "transparent" }}
          d="M500.68,300.89l-1.13,127.45c0,2.13,0,4.37,1,6.22,2.27,4,7.88,4.14,12.46,3.81a899.61,899.61,0,0,1,188,6.05,350.15,350.15,0,0,0,4.26-122.35c-1-7-2.44-14.51-7.36-19.64-6.65-6.92-17.37-7.43-27-7.49l-133.43-.75c-13.19-.07-26.6-.11-39.23,3.67"
        />
        <path
          onClick={onClick}
          name="8"
          style={{ fill: "transparent" }}
          d="M408.35,634.2,373.61,630c-4.33-.52-8.79-1.07-12.62-3.16s-6.6-5.4-9.36-8.67c-10.27-12.21-21-25.5-22.46-41.4-1-11.24,2.81-22.3,6.57-32.94,1.47-4.14,3-8.35,5.59-11.89,3.21-4.34,7.86-7.35,12.41-10.26,17-10.85,34.6-22,54.53-24.75,21.64-3,47.1,3,62.92-12,4.81-4.58,8-10.62,12.5-15.48,13.94-15,37-15.86,57.47-15.67l105.63,1c18,.16,36.83.54,52.59,9.22C711,470.39,719.8,480.7,730,489.16a114.84,114.84,0,0,0,53.59,24.72c10.44,1.8,21.23,2.17,31.18,5.8,16.78,6.13,29.36,20.85,46.22,26.76,9.2,3.23,19.63,3.83,27.38,9.76,10.51,8,12.47,22.92,12.39,36.14,0,5.11-.29,10.41-2.58,15-8,16-32.59,12.23-46.94,22.87-8.37,6.2-12.45,16.79-20.39,23.53-13.37,11.35-33.81,8.75-49.79,1.51s-30.25-18.38-47.13-23.12c-10.81-3-22.17-3.29-33.4-3.52l-163-3.33c-7.82-.16-16.19-.16-22.68,4.2-9.94,6.68-11.61,20.79-19.69,29.63-12.37,13.52-34.43,10.2-51.46,3.44-12.94-5.14-26.68-13.23-29.88-26.79"
        />
        <path
          onClick={onClick}
          name="1"
          style={{ fill: "transparent" }}
          d="M494.56,745.14c12-4,23.14-10.18,34.34-16.07A834.11,834.11,0,0,1,624,686.33c4.82-1.82,9.72-3.6,14.84-4.15,13.85-1.48,26.87,6.13,38.71,13.45l61,37.71c17.5,10.81,35.28,21.75,55.07,27.36,14.64,4.16,33.59,8.69,35.68,23.76-15.83,1.37-27.23,15.17-40.79,23.46-20.58,12.58-47.31,12.75-66.78,27-6.78,5-12.61,11.57-20.5,14.44-12.84,4.68-26.79-1.83-38.89-8.18L498.18,755c-2.68-1.41-5.6-3.1-6.5-6s2.1-6.69,4.77-5.26"
        />
        <path
          onClick={onClick}
          name="11"
          style={{ fill: "transparent" }}
          d="M22.78,764.06q17.67,86.21,40.4,171.27,113.07-21.09,225.46-45.6a30.42,30.42,0,0,0,8-2.53c11.75-6.34,10-23.48,6.59-36.39q-17.78-67.15-35.56-134.29c-1.52-5.77-3.41-12-8.39-15.33-5.5-3.63-12.76-2.3-19.19-.84L43.37,745c-6.76,1.54-13.84,3.23-19,7.82s-7.65,13.09-3.42,18.59"
        />

        <path
          onClick={onClick}
          name="14"
          style={{ fill: "transparent" }}
          d="M375.68,936.62l12.81,54.69c1.72,7.31,4.42,15.76,11.53,18.16,2.5.84,5.22.77,7.77,1.43,8.51,2.21,12.72,11.47,16.57,19.39s10.46,16.54,19.2,15.5c3.65-.43,6.95-2.59,10.61-2.94,5.46-.51,10.36,3,15.06,5.8a74.61,74.61,0,0,0,65,5.25c6.34-2.53,12.4-6,19.11-7.26,7.63-1.48,16.31-.3,22.43-5.1,6.81-5.33,8.47-16.77,16.82-19,2.75-.76,5.91-.34,8.23-2,3.29-2.34,3-7.17,3.53-11.17,1.61-11.07,12.34-18.48,22.87-22.26s22.05-5.48,31.3-11.78c11.82-8,18-22.63,18.8-36.92s-3-28.41-7.69-41.93A332.71,332.71,0,0,0,655,860.77c-2.5-5.17-5.33-10.51-10.12-13.68-5.85-3.87-13.41-3.73-20.4-3.17-41.73,3.34-81.93,16.63-121.66,29.82l-107,35.55c-6.66,2.21-13.54,4.55-18.68,9.33s-8,12.74-4.87,19"
        />

        <path
          onClick={onClick}
          name="7"
          style={{ fill: "transparent" }}
          d="M936.49,853.5c2.2,18.21-7.58,36.21-5.84,54.47,1.6,16.79,12.57,31,23.27,44,7.55,9.2,15.33,18.46,25.2,25.12,31.76,21.44,74.34,10.53,110.84-1.11,13.29-4.24,27.4-9,36-20,7.93-10.09,9.74-23.54,11.25-36.28q2.49-20.85,5-41.7c3.56-29.87,4.82-65.58-19-83.88C1110,784.11,1092.51,782.35,1076,781l-29.57-2.49c-24.76-2.08-50.58-4-73.67,5.16s-42.38,33.1-37.6,57.49"
        />
        <path
          onClick={onClick}
          name="9"
          style={{ fill: "transparent" }}
          d="M763.09,436.19c2-15.66-3.39-33.23,5.39-46.36,6.31-9.45,18.15-13.37,29.27-15.7,10.36-2.17,21.06-3.5,31.5-1.84,17,2.7,32.28,13.55,41.31,28.18s11.9,32.73,8.83,49.65c-.31,1.67-.73,3.44-2,4.55-2.15,1.87-5.45.93-8.27,1.32-9.06,1.27-10,14.38-16.72,20.57-3.68,3.37-8.88,4.4-13.79,5.29-14.73,2.68-30.45,5.26-44.23-.57-17.57-7.43-27.15-26.49-32.21-44.88"
        />

        <path
          onClick={onClick}
          name="17"
          style={{ fill: "transparent" }}
          d="M347.22,202a129.31,129.31,0,0,0-7.68,31.77c-.27,2.43-.44,5,.76,7.15,1.34,2.39,4.06,3.6,6.6,4.64,6.75,2.78,13.57,5.57,20.76,6.8,6.19,1.06,12.51.94,18.78.82l43.26-.85c4.21-.08,8.68-.24,12.19-2.56,2.94-2,4.8-5.16,6.1-8.43a40.48,40.48,0,0,0-8.36-42.24c-8.91-9.16-21.88-13.5-34.63-14.28s-25.46,1.67-37.94,4.38c-7,1.52-14.85,3.75-18.19,10.1"
        />
        <path
          onClick={onClick}
          name="3"
          style={{ fill: "transparent" }}
          d="M617.15,198.37c1-10.27,6.07-19.83,12.82-27.64,19.44-22.52,52.89-30.46,81.54-22.43,9.93,2.79,19.87,7.71,25.41,16.41,7.94,12.46,4.81,28.6,6.32,43.3,1.09,10.51,4.68,21.21,1.86,31.39-4.56,16.53-23.88,24.26-41,25s-34.62-3-51.24,1.2c-3.72.94-7.79,2.23-11.2.5a11.88,11.88,0,0,1-4.31-4.34c-12.23-18.59-6.67-44.28-16.92-64"
        />

        <path
          onClick={onClick}
          name="12"
          style={{ fill: "transparent" }}
          d="M1017,289.8l-3.62,89.78c-.22,5.51-.21,11.66,3.58,15.65s9.54,4.32,14.86,4.52c96.73,3.59,193.81,1.87,290.07,12.14,16.26,1.74,32.78,3.81,48.87.86s32-11.85,39-26.63l-9.29,7.21a343.47,343.47,0,0,0,5.4-87.59c-.16-2.39-.44-5-2.17-6.67s-4.35-1.85-6.74-1.95l-376-15.38-3.07,12.72"
        />

        <path
          onClick={onClick}
          name="10"
          style={{ fill: "transparent" }}
          d="M1450.37,332.78a24.05,24.05,0,0,1-6.58,27.8c-2.23,1.8-4.84,3.26-6.41,5.66-3,4.55-1.07,10.78,2.11,15.19s7.53,8,10,12.87c6.32,12.42,0,31.6,12.14,38.54,3.2,1.83,7,2.19,10.69,2.49a1379.73,1379.73,0,0,0,232-.52c24.77-2.14,53.15-7.23,65.52-28.8,4.93-8.58,6.48-18.64,7.82-28.45q3.07-22.6,5.26-45.32c.2-2,.31-4.31-1-5.84-1.17-1.33-3.07-1.66-4.83-1.86a78.85,78.85,0,0,0-37.36,5c-4.92-11.28-10.38-23.23-20.78-29.81-12-7.63-27.51-6.13-41.65-4.35L1483,319.81c-12.4,1.56-25.18,3.24-36,9.52"
        />
        <path
          onClick={onClick}
          name="6"
          style={{ fill: "transparent" }}
          d="M1461.44,446l0,179,120.44,17.45a1398.4,1398.4,0,0,0,10.35-143.73c.27-13.4.33-27-3.34-39.92-.74-2.58-1.74-5.3-3.93-6.86-1.91-1.35-4.36-1.58-6.68-1.77a1029.45,1029.45,0,0,0-112.88-2.66"
        />
        <path
          onClick={onClick}
          name="18"
          style={{ fill: "transparent" }}
          d="M1598.63,498.3l-1.45,101.42c26.88-.73,53.58,3.91,80.07,8.53l120,20.92c10.33-31.27,8.29-65.11,6.15-98l-2.53-38.72c-.18-2.74-.57-5.86-2.83-7.41-1.49-1-3.42-1.06-5.22-1.06A742.29,742.29,0,0,0,1666,494.85c-21.7,3.76-44.65,8.38-65.2.47"
        />

        <path
          onClick={onClick}
          name="16"
          style={{ fill: "transparent" }}
          d="M1449.56,931.17l-2.65-57.65c-.65-14.13-.21-30.69,11.21-39,3.69-2.71,8.32-4.31,11.09-7.94,2.26-2.95,2.93-6.79,3.41-10.47,2.89-22.06,2.31-46.43,16.37-63.67,18.06-22.12,51.25-22.15,79.75-20.27L1703,741c6.29.42,13.58,1.42,16.79,6.84,2.67,4.52,1.33,10.34,2.82,15.38,3.65,12.39,20.21,13.58,33,15.43,2.64.38,5.4,1,7.43,2.7,2.26,1.93,3.21,5,3.86,7.86a65.07,65.07,0,0,1-1.67,34.32,114.13,114.13,0,0,1,28.75,2c3,.6,6.35,1.51,8.12,4.07s1.43,6,1,9.17q-5,36.46-10.07,72.91c-.88,6.34-1.87,13-5.7,18.11-7.32,9.8-21.57,10.28-33.79,9.85l-41-1.43c-9.88-.35-20.73-.38-28.37,5.89-3.61,2.95-6.1,7-9.48,10.26-8,7.67-19.95,9.43-31,10.07-54,3.1-107.4-11.52-161.35-15.68-7.09-.55-14.34-1-20.89-3.7s-12.39-8.4-13.18-15.46"
        />

        <path
          onClick={onClick}
          name="5"
          style={{ fill: "transparent" }}
          d="M307.16,846.45a262.89,262.89,0,0,0-5.31-65.74C297,757.6,289,734.59,290.71,711s17-48.49,40.49-51.27c4.42-.52,8.91-.24,13.33-.76,21.68-2.58,40.88-24.09,61.69-17.51,3.39,6.84.25,16.14-6.59,19.51a49.56,49.56,0,0,1,32,20c.76,1.07,1.51,2.39,1.05,3.62s-2.06,1.76-3.43,2.06c-11.37,2.47-24.33,6.31-28.88,17,6.81.5,9.09,9.27,9.47,16.09a860,860,0,0,1-2.13,126.58c-.47,5.11-1,10.33-3.2,15-3.29,7-10,11.84-17.3,14.32-5.73,2-11.82,2.59-17.85,3.12-16.75,1.47-34.57,2-49.32-6-10.37-5.68-18.74-19.11-12.35-29.07"
        />

        <path
          onClick={onClick}
          name="2"
          style={{ fill: "transparent" }}
          d="M1045.48,507c-14,6.55-16,25.33-15.92,40.79q.07,27.11.13,54.21c0,11.31.08,22.83,3.52,33.6s10.88,20.88,21.54,24.65,24.41-.7,28.56-11.22c2-5.13,2.25-11.83,7.11-14.42A34.41,34.41,0,0,0,1108.84,647a108.55,108.55,0,0,0-1.92,36.34c1.53,13.12,6.25,27,17.36,34.16,10.63,6.83,25,5.67,36.06-.51s19-16.67,25-27.81c1-1.79,1.94-3.69,3.66-4.75a11.1,11.1,0,0,1,5.5-1.18,692.54,692.54,0,0,1,105.7,4.25c-5.9,5.79.3,15.46,6.31,21.13,4,3.76,8.08,7.6,13.15,9.65,7.73,3.14,16.47,1.69,24.67.19l20-3.65c2.64-.49,5.42-1,7.45-2.8s3-4.71,3.9-7.4a178.68,178.68,0,0,1,33.41-60c6.23-7.36,13.33-14.73,15.3-24.17,1.77-8.45-.89-17.13-3.53-25.35l-12.93-40.37c-1.86-5.82-3.81-11.8-7.74-16.48-10.63-12.65-30.65-11-45-19.26-24.51-14.15-27-53.65-53.41-63.92-5.15-2-10.74-2.61-16.25-3.14a796.93,796.93,0,0,0-162,1c-8.24.89-16.77,2-23.78,6.45-8.78,5.54-14.09,15.61-23.2,20.61-5.62,3.09-12.22,4-17.93,6.89s-10.68,9.31-8.62,15.39"
        />
      </g>
    </svg>
  );
};
